<div class="d-flex align-items-center translation-row-padding" [ngClass]="{'edited': isEdited}">
  <div class="input-group">
    <input [readOnly]="readOnly" type="text" [(ngModel)]="sprogLag.vaerdi" class="form-control"
      (ngModelChange)="handleChange($event)" [tabIndex]="tabIndex" (keydown)="handleKeydown($event)"
      [disabled]="translationContext.waitingForNetwork ?? false" />
    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
      aria-expanded="false">
    </button>
    <ul class="dropdown-menu dropdown-menu-end">
      <li><a class="dropdown-item" (click)="expandText($event)">
          <i class="fa-regular fa-message-text"></i> Udvid</a></li>
      @if (!readOnly) {
      <li>
        <hr class="dropdown-divider">
      </li>
      <li><a class="dropdown-item" (click)="suggestTranslation($event)">
          <i class="fas fa-robot"></i> Oversæt med DeepL</a></li>
      <li><a class="dropdown-item" (click)="translateAll($event)">
          <i class="fas fa-robot"></i><i class="fa-solid fa-share-all fa-sm"></i> Oversæt andre tomme felter</a></li>
      }
    </ul>
  </div>
</div>